import React from "react";
import ImageWithFallback from "../../../ImageWithFallback/ImageWithFallback";
import styles from "./parts.module.css";

type Props = {
  imageUrl: string;
};

const BoxItemImage = ({ imageUrl }: Props) => {
  return (
    <div className={styles["image-container"]}>
      <ImageWithFallback mainSrc={imageUrl} />
    </div>
  );
};

export default BoxItemImage;
